import { connect as connectRedux } from 'react-redux';
import { connect } from 'react-jplaylist';
import DemoVideoView from '../../../common/components/demoVideos/DemoVideoView';
import { LC_PLAYLIST, LC_OPTIONS } from '../../../common/components/demoVideos/demoVideoConstants';
import selectors from '../../../rootSelectors';
import { playPlaylist } from '../../lcActions';

const mapDispatchToProps = dispatch => ({
    narrateScreen: () => {
        return Promise.resolve();
    },
    playPlaylist: playlistIndex => dispatch(playPlaylist(playlistIndex)),
    cleanup: () => {},
});

const mapStateToProps = state => ({
    activeVideoId: selectors.getLCActiveDemoVideoId(state),
    demoVideosProgress: selectors.getLCDemoVideosProgress(state),
    areAllDemoVideosWatched: selectors.areAllLCDemoVideosWatched(state),
    nextIncompletePlaylistItem: selectors.getNextIncompleteMeasure(state),
});

const { LC_PRACTICE } = LC_PLAYLIST;

const jPlaylistOptions = {
    loopOnPrevious: false,
    loop: 'off',
    playlist: [
        {
            artist: '',
            title: LC_PRACTICE.TITLE,
            demoVideoId: LC_PRACTICE.ID,
            sources: {
                m4v: `${LC_OPTIONS.lcPracticeVideoBucketCDN}/${LC_PRACTICE.FILE_NAME}`,
            },
        },
    ],
};

export default connectRedux(
    mapStateToProps,
    mapDispatchToProps,
)(connect(DemoVideoView, LC_OPTIONS, jPlaylistOptions));
